var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":_vm.width,"height":_vm.height || _vm.width,"aria-label":_vm.title,"aria-hidden":!_vm.title,"focusable":"false","role":"img"}},[_c('use',{attrs:{"xlink:href":("icons.svg#app-icon-" + _vm.icon)}})])}
var staticRenderFns = []

export { render, staticRenderFns }